module.exports = __webpack_public_path__ + "static/media/four_point_five.99407d0c.png";